import React from 'react';
import { useTranslation } from 'react-i18next';
import { List } from '@mui/material';
import { Assignment, Business, EmojiEvents, FitnessCenter, Group, Payment, Restaurant, SupportAgent } from '@mui/icons-material';
import {
  AccountBoxMultiple,
  ChartBoxOutline,
  ClipboardList,
  NewspaperVariantOutline,
  WeightLifter
} from 'mdi-material-ui';
import CollapsibleMenuItem from 'components/shared/menus/CollapsibleMenuItem';
import MenuItem from 'components/shared/menus/MenuItem';
import NestedMenuItem from 'components/shared/menus/NestedMenuItem';
import routes from 'common/routes';

function AdminMoreHub() {
  const { t } = useTranslation(['routes', 'pqrs']);

  return (
    <List>
      <MenuItem
        icon={<NewspaperVariantOutline />}
        itemKey="news"
        label={t('news.list', { ns: 'routes' })}
        path={routes.listNews.path}
      />
      <MenuItem
        icon={<Group />}
        itemKey="groupSessions"
        label={t('session.groupSessions', { ns: 'routes' })}
        path={routes.groupSessions.path}
      />
      <MenuItem
        icon={<WeightLifter />}
        itemKey="sessionTypes"
        label={t('sessionType.list', { ns: 'routes' })}
        path={routes.listSessionType.path}
      />
      <CollapsibleMenuItem
        icon={<FitnessCenter />}
        label="Ejercicios"
        noLink>
        <NestedMenuItem
          label={t('exercise.list', { ns: 'routes' })}
          path={routes.exercises.path}
        />
        <NestedMenuItem
          label="Solicitudes"
          path={routes.exerciseRequests.path}
        />
        <NestedMenuItem
          label={t('play.moderation', { ns: 'routes', defaultValue: 'Moderación OTRIX Play' })}
          path={routes.playModeration.path}
        />
        <NestedMenuItem
          label={t('play.musicAdmin', { ns: 'routes', defaultValue: 'Música Play' })}
          path={routes.playMusicAdmin.path}
        />
        <NestedMenuItem
          label={t('play.recoveryAdmin', { ns: 'routes', defaultValue: 'Prácticas de descanso' })}
          path={routes.playRecoveryAdmin.path}
        />
      </CollapsibleMenuItem>
      <CollapsibleMenuItem
        icon={<ClipboardList />}
        label={t('plan.list', { ns: 'routes' })}
        noLink>
        <NestedMenuItem
          label={t('plan.list', { ns: 'routes' })}
          path={routes.listPlan.path}
        />
        <NestedMenuItem
          label="Solicitudes"
          path={routes.planRequests.path}
        />
      </CollapsibleMenuItem>
      <MenuItem
        icon={<Restaurant />}
        itemKey="nutrition"
        label={t('mealPlan.list', { ns: 'routes' })}
        path={routes.listMealPlan.path}
      />
      <MenuItem
        icon={<ChartBoxOutline />}
        itemKey="performance"
        label={t('performance.list', { ns: 'routes' })}
        path={routes.listPerformance.path}
      />
      <MenuItem
        icon={<AccountBoxMultiple />}
        itemKey="progress"
        label={t('progress.list', { ns: 'routes' })}
        path={routes.listProgress.path}
      />
      <MenuItem
        icon={<EmojiEvents />}
        itemKey="ranking"
        label="Ranking Global"
        path={routes.globalRanking.path}
      />
      <CollapsibleMenuItem
        icon={<Payment />}
        label={t('payment.payments', { ns: 'routes' })}
        noLink>
        <NestedMenuItem
          label={t('client.list', { ns: 'routes' })}
          path={routes.listClientPayments.administrator.path}
        />
        <NestedMenuItem
          label={t('trainer.list', { ns: 'routes' })}
          path={routes.listTrainerPayments.administrator.path}
        />
        <NestedMenuItem
          label={t('billingInfo', { ns: 'routes', defaultValue: 'Datos de facturación' })}
          path={routes.billingInfo.path}
        />
      </CollapsibleMenuItem>
      <CollapsibleMenuItem
        icon={<Group />}
        label={t('users', { ns: 'routes' })}
        noLink
        path={routes.users.path}>
        <NestedMenuItem
          label={t('administrator.list', { ns: 'routes' })}
          path={routes.listAdmin.path}
        />
        <NestedMenuItem
          label={t('supervisor.list', { ns: 'routes' })}
          path={routes.listSupervisor.path}
        />
        <NestedMenuItem
          label={t('client.list', { ns: 'routes' })}
          path={routes.listClient.path}
        />
        <NestedMenuItem
          label={t('trainer.list', { ns: 'routes' })}
          path={routes.listTrainer.path}
        />
      </CollapsibleMenuItem>
      <MenuItem
        icon={<Business />}
        itemKey="organizations"
        label={t('organizations', { ns: 'routes', defaultValue: 'Organizaciones' })}
        path={routes.adminOrganizations.path}
      />
      <MenuItem
        icon={<Assignment />}
        itemKey="legal"
        label={t('legal.list', { ns: 'routes' })}
        path={routes.listLegal.path}
      />
      <MenuItem
        icon={<SupportAgent />}
        itemKey="pqrs"
        label={t('title', { ns: 'pqrs', defaultValue: 'PQRS' })}
        path={routes.adminPqrs.path}
      />
    </List>
  );
}

export default AdminMoreHub;
